import { loadModal } from '../../AsyncLoader';
import SyosPageComponent from '../components/SyosPageComponent';
import { srOnlyElement } from '../../utils/screen-reader/html';
import SyosEvents from '../utils/SyosEvents';
import type SyosController from '../SyosController';
import type AlertModalHandle from '../../tnew/ui/Modal/AlertModalHandle';

const getBodyContents = () => {
  const BASE_CLASS = 'tn-syos-key-commands-modal';

  const {
    keyCommandsModalDescription,
    labelAvailableKeyCommands,
    labelAction,
    labelCommand,

    labelNavigateSeats,
    labelZoomIn,
    labelZoomOut,
    labelPanOut,
    labelPanDown,
    labelPanLeft,
    labelPanRight,
    labelResetPanAndZoom,
    labelJumpToFirstSeatInRow,
    labelJumpToLastSeatInRow,
    labelJumpToFirstRow,
    labelJumpToLastRow,
    labelJumpToFirstSeatInSection,
    labelJumpToLastSeatInSection,
  } = SyosPageComponent;

  const commands = [
    [labelZoomIn, '<kbd>+</kbd>', 'Plus'],
    [labelZoomOut, '<kbd>-</kbd>', 'Minus'],
    [labelPanOut, '<kbd>Shift</kbd> + <kbd>↑</kbd>', 'Shift and Up'],
    [labelPanDown, '<kbd>Shift</kbd> + <kbd>↓</kbd>', 'Shift and Down'],
    [labelPanLeft, '<kbd>Shift</kbd> + <kbd>←</kbd>', 'Shift and Left'],
    [labelPanRight, '<kbd>Shift</kbd> + <kbd>→</kbd>', 'Shift and Right'],
    [labelResetPanAndZoom, '<kbd>0</kbd>', '0'],
    [labelNavigateSeats, '<kbd>↑</kbd> <kbd>↓</kbd> <kbd>←</kbd> <kbd>→</kbd>', 'Up, Down, Left, or Right'],
    [labelJumpToFirstSeatInRow, '<kbd>Home</kbd>', 'Home'],
    [labelJumpToLastSeatInRow, '<kbd>End</kbd>', 'End'],
    [labelJumpToFirstRow, '<kbd>Shift</kbd> + <kbd>Home</kbd>', 'Shift and Home'],
    [labelJumpToLastRow, '<kbd>Shift</kbd> + <kbd>End</kbd>', 'Shift and End'],
    [labelJumpToFirstSeatInSection, '<kbd>Control</kbd> + <kbd>Home</kbd>', 'Control and Home'],
    [labelJumpToLastSeatInSection, '<kbd>Control</kbd> + <kbd>End</kbd>', 'Control and End'],
  ];

  return `<div class="${BASE_CLASS}__description">${keyCommandsModalDescription}</div>
  <table class="table table-condensed ${BASE_CLASS}__table">
    ${srOnlyElement('caption', `<h2>${labelAvailableKeyCommands}</h2>`)}
    <thead>
      <tr>
        <th>${labelAction}</th>
        <th>${labelCommand}</th>
      </tr>
    </thead>
    <tbody>
      ${commands.map(([action, command, ariaLabel]) => `<tr>
          <td>${action}</td>
          <td>
            <span aria-hidden="true">${command}</span>
            <span class="sr-only">${ariaLabel}</span>
          </td>
        </tr>`).join('')}
    </tbody>
  </table>`;
};

let openModal: AlertModalHandle | undefined;

const open = async (syosController: SyosController) => {
  if (openModal) {
    return;
  }

  const Modal = await loadModal();

  openModal = Modal.alert({
    closeButtonInHeader: true,
    describedById: 'tn-syos-key-commands-modal',
    title: SyosPageComponent.labelAvailableKeyCommands,
    bodyContents: getBodyContents(),
    beforeClose: () => {
      openModal = undefined;
    },
    beforeRemove: () => {
      syosController.emit(SyosEvents.MODAL_CLOSE);
    },
  });
};

export default {
  open,
};
